import React, { useState } from "react";
import "./tilaus-ja-ohjeet.m.css";

const TilausJaOhjeet = () => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);

  return (
    <div styleName="container">
      <div styleName="hero-image">
        <img src="https://s3-alpha-sig.figma.com/img/1c4c/1c56/077c2920d9ec8655d049089c2dfacbc7?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dG6Kpz7yVoaNo4Xqy0f~Zu-YtharChBXABuKbes3TgZwcP~mkvxCeaaex5IesfogwariSqGsTKGdpeHwW2nBJmzm0ZHLRjtTsEKkKUq7vcu69Nxva9~fXL1EZ68PXfl0j332mspOqULI57~zbGXa-~kmf40fq631-v3SLbq4BoUbLj5zjXadGFp0G-fA5c2XMg2Dn0obIbafLT0hqVUWtKST3QEGdbogMiF-f0APZbKDEJYuOC2vURfNCxkwy4hRvYN-FQYW52uCc4BHlpFCQ~LoroQkHZaGXqnhHb~wTf6W3j7cfNWpj01HCtMTLKPZCKpn3R71mq9NTsigVulloA__" />
        <div styleName="header-one">
          <h2>Tilaus ja käyttöehdot</h2>
          <p>Päivitetty: 20.3.2025</p>
        </div>
      </div>

      <div styleName="container-listing">
        <div styleName="list-item">
          <div styleName="number">1</div>
          <div styleName="text">
            <h3>Yleistä</h3>
            <p>
              Näitä ehtoja sovelletaan Dei Plus -suoratoistopalvelun ("Palvelu") tilauksiin ja käyttöön. "Asiakkaalla"
              ja ”Käyttäjällä” tarkoitetaan Palvelun tilaajaa.
            </p>
            <p>
              Palvelua käyttävä henkilö (jäljempänä "Käyttäjä") vakuuttaa tutustuneensa ehtoihin ja sitoutuu kaikilta
              osin noudattamaan niitä sekä muita mahdollisia Palveluun liittyviä lisäehtoja ja ohjeita. Mikäli Tilaus-
              ja käyttöehdot ja erityisehdot ovat ristiriidassa, sovelletaan ensisijaisesti erityisehtoja.
            </p>
            <p>
              Mikäli Palvelu on hankittu kolmannen osapuolen alustalta (esim. Google Play, App Store), sovelletaan
              lisäksi kyseisten palveluntarjoajien ehtoja.
            </p>
          </div>
        </div>
        <div styleName="list-item">
          <div styleName="number">2</div>
          <div styleName="text">
            <h3>Palvelun tilausmuodot</h3>
            <p>
              Palvelun käyttäminen edellyttää rekisteröitymistä ja näiden tilausehtojen hyväksymistä. Asiakkaan on
              oltava täysi-ikäinen. Sopimus syntyy, kun Asiakas hyväksyy tilausehdot ja vahvistaa tilauksen.
            </p>
            <div styleName="sub-headline-wrapper number-sub-points">
              <div styleName="sub-headline">
                <div styleName="number">2.1</div>
                <h3>Tilausvaihtoehdot</h3>
              </div>
              <p>
                Toistaiseksi voimassa oleva tilaus jatkuu ilman uudistamista, kunnes se irtisanotaan. Irtisanominen
                astuu voimaan kuluvan tilauskauden päätyttyä.
              </p>
              <p>
                Määräaikainen tilaus on voimassa sovitun ajan, eikä sitä voi irtisanoa kesken kauden. Tilauksen
                päättyessä se muuttuu automaattisesti toistaiseksi voimassa olevaksi, ellei Asiakas erikseen irtisano
                sitä.
              </p>
            </div>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">3</div>
          <div styleName="text">
            <h3>Palvelun sisältö ja käyttäminen</h3>
            <p>
              Dei Plus tarjoaa suoratoistosisältöjä, kuten videoita, musiikkia ja podcasteja. Palveluntarjoaja voi
              muuttaa saatavilla olevaa sisältöä ilman erillistä ilmoitusta.
            </p>
            <div styleName="sub-headline-wrapper number-sub-points">
              <div styleName="sub-headline">
                <div styleName="number">3.1</div>
                <h3>Tilausvaihtoehdot</h3>
              </div>
              <p>Palvelua voi käyttää yhä yhdellä laitteella kerrallaan, ellei toisin mainita. Palvelun käyttö edellyttää internet-yhteyttä ja yhteensopivaa laitetta.</p>
            </div>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">4</div>
          <div styleName="text">
            <h3>Maksut ja irtisanominen</h3>

            <div styleName="sub-headline-wrapper number-sub-points">
              <div styleName="sub-headline">
                <div styleName="number">4.1</div>
                <h3>Maksut</h3>
              </div>
              <p>
                Palvelun tilaus veloitetaan kuukausittain tai tilauksen yhteydessä sovitulla tavalla. Maksutavat ja
                hinnasto on nähtävissä Dei Plus -verkkosivuilla.
              </p>
            </div>

            <div styleName="sub-headline-wrapper number-sub-points">
              <div styleName="sub-headline">
                <div styleName="number">4.2</div>
                <h3>Irtisanominen</h3>
              </div>
              <p>
                Toistaiseksi voimassa olevan tilauksen voi irtisanoa Dei Plus -palvelun itsepalvelussa tai
                asiakaspalvelun kautta. Määräaikaisia tilauksia ja kertatilauksia ei voi irtisanoa kesken tilauskauden.
              </p>
            </div>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">5</div>
          <div styleName="text">
            <h3>Maksuttomat kokeilujaksot</h3>
            <p>
              Uusille asiakkaille voidaan tarjota maksuton kokeilujakso. Jos tilausta ei peruuteta kokeilujakson aikana,
              se muuttuu maksulliseksi tilaukseksi.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">6</div>
          <div styleName="text">
            <h3>Käyttäjätili ja tunnukset</h3>
            <p>
              Palveluiden käyttö edellyttää käyttäjätilin luomista ja kirjautumista. Käyttäjä vastaa tunnustensa
              turvallisuudesta ja on velvollinen ilmoittamaan mahdollisista väärinkäytöksistä palveluntarjoajalle.
              Käyttäjätunnukset ovat henkilökohtaisia, eikä niitä saa jakaa kolmansille osapuolille.
            </p>
            <p>
              Palveluntarjoajalla on oikeus sulkea käyttäjätili, jos sitä käytetään vilpillisesti tai ehtojen
              vastaisesti.{" "}
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">7</div>
          <div styleName="text">
            <h3>Palvelun käyttörajoitukset</h3>
            <p>
              Käyttäjä ei saa kuormittaa Palvelua automaattisilla järjestelmillä (esim. botit ja spider-ohjelmat) eikä
              käyttää sitä datanlouhintaan tai tekoälymallien kouluttamiseen ilman erillistä lupaa.{" "}
            </p>
            <p>
              Palveluntarjoajalla on oikeus estää pääsy Palveluun, jos se häiritsee muuta verkkoliikennettä tai uhkaa
              tietoturvaa.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">8</div>
          <div styleName="text">
            <h3>Kolmannen osapuolen palvelut</h3>
            <p>
              Kolmannen osapuolen palvelut (esim. App Store, Google Play) voivat sisältää omia ehtojaan, jotka käyttäjän
              tulee hyväksyä.{" "}
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">9</div>
          <div styleName="text">
            <h3>Palkinnot ja kilpailut</h3>
            <p>
              Palvelun yhteydessä voidaan järjestää arvontoja ja kilpailuja. Palkinnot voivat olla veronalaisia, ja
              järjestäjä varaa oikeuden muuttaa palkintoja ilman ennakkovaroitusta.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">10</div>
          <div styleName="text">
            <h3>Immateriaalioikeudet ja sisällön käyttö</h3>
            <p>
              Palvelun sisältö on suojattu tekijänoikeuslailla. Käyttäjä myöntää palveluntarjoajalle oikeuden käyttää
              Palveluun ladattua sisältöä journalistisiin ja kaupallisiin tarkoituksiin ilman erillistä korvausta.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">11</div>
          <div styleName="text">
            <h3>Tietosuoja ja evästeet</h3>
            <p>
              Palveluntarjoaja voi tallentaa asiakaspalvelupuheluita ja käyttää käyttäjätietoja analytiikkaan ja
              mainonnan kohdentamiseen. Palvelu käyttää evästeitä käyttäjäkokemuksen parantamiseen.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">12</div>
          <div styleName="text">
            <h3>Riidan ratkaisu ja sovellettava laki</h3>
            <p>
              Näihin Käyttöehtoihin sovelletaan Suomen lakia. Kuluttajalla on oikeus viedä riita-asia
              kuluttajariitalautakuntaan tai Euroopan komission verkkovälitteiseen riidanratkaisupalveluun.
            </p>
          </div>
        </div>

        <div styleName="list-item">
          <div styleName="number">13</div>
          <div styleName="text">
            <h3>Palvelun muutokset</h3>
            <p>
              Verkkopalveluiden tarjoaja pyrkii varmistamaan palveluiden jatkuvan saatavuuden ja virheettömän toiminnan,
              mutta ei voi taata niiden keskeytyksetöntä tai virheetöntä toimintaa. Verkkopalveluiden sisältöä ja
              ominaisuuksia voidaan muuttaa tai poistaa ilman ennakkoilmoitusta.
            </p>
            <p>
              Palveluntarjoaja voi muuttaa Käyttöehtoja ilmoittamalla siitä etukäteen. Käyttäjän tulee lopettaa Palvelun
              käyttö, jos hän ei hyväksy muutoksia.{" "}
            </p>
          </div>
        </div>
      </div>

      <div styleName="web-usage-instructions instructions-lower">
        <h2>Yhteystiedot</h2>
        <p>
          Plus Asiakaspalvelu <br />
          <a href="www.deiplus.fi/asiakaspalvelu">www.deiplus.fi/asiakaspalvelu</a>
          <br />
          Puhelin: 020 123 4567<br />
          Sähköposti: <a href="mailto:asiakaspalvelu@deiplus.fi">asiakaspalvelu@deiplus.fi</a>
        </p>
      </div>
    </div>
  );
};

export { TilausJaOhjeet };
